<template>
  <div>
    <vuestic-pre-loader v-show="isLoading" :total="total" :current="current" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
    <!-- Table Header Component -->
    <table-header v-if="!isLoading"
      :multiSelectCount = "multiSelectCount"
      :buttonMultiEdit = "buttonMultiEdit"
      :buttonMultiDelete = "buttonMultiDelete"
      :button = "button"
      :buttonAction = "buttonAction"
      :clearAll = "clearAll"
      :listDefinition = "listDefinition"
      :csvDefinition = "csvDefinition"
      :filter = "filter"
      :filteredData = "filteredData"
      :search = "search"
      :option = "option"
      :removeFunction = "removeFunction"
      :policy = "policy"
      :showHeader = "false"
    />
    <!-- Table Body Component -->
    <table-body v-if="!isLoading"
      :listDefinition = "listDefinition"
      :multiSelectAll = "multiSelectAll"
      :multiSelectCount = "multiSelectCount"
      :multiSelectChange = "multiSelectChange"
      :multiSelect = "multiSelect"
      :sortBy = "sortBy"
      :sortOrders = "sortOrders"
      :sortKey = "sortKey"
      :displayData = "displayData"
      :search = "search"
      :option = "option"
      :filteredObject = "filteredObject"
      :filteredData = "filteredData"
      :pageNo = "pageNo"
      :perPage = "perPage"
      :perPageChange = "perPageChange"
      :onChangePage = "onChangePage"
      :onNextPage = "onNextPage"
      :onPreviousPage = "onPreviousPage"
      :onFirstPage = "onFirstPage"
      :onLastPage = "onLastPage"
      :policy = "policy"
      :client = "client"
      :objectEdit = "objectEdit"
      :objectDelete = "objectDelete"
    />

    <!-- Multi Delete model -->
    <vuestic-modal ref="multiDeleteModal" :cancelClass="'none'" :okClass="'none'">
      <div slot="title">Do you want to delete following {{ objects.length }} {{ title }}?</div>
      <vuestic-alert type="danger">
        <span class="badge badge-pill badge-danger">Danger!</span>
        You will not be able to reverse this action!
      </vuestic-alert>
      <div class="objects-div">
        <p v-for="object in objects">{{ object }}</p>
      </div>
      <button class="btn btn-secondary btn-micro" @click="hideMultiDeleteModal()">
        CANCEL
      </button>
      <button class="btn btn-danger btn-micro" @click="multiDelete()">
        DELETE
      </button>
    </vuestic-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'
  import store from '../../../../store'

  export default {
    name: 'list-object-active',
    mounted: function () {
      this.getObjects()
    },
    props: {
      listDefinition: {
        type: Object,
        default: () => {}
      },
      csvDefinition: {
        type: Object,
        default: () => {}
      },
      client: {
        type: Object
      },
      button: {
        type: Boolean,
        default: false
      },
      buttonTitle: {
        type: String,
        default: 'Add'
      },
      buttonAction: {
        type: Function
      },
      multiSelectAction: {
        type: Function
      },
      policy: {
        type: Function
      },
      objectEdit: {
        type: Boolean,
        default: true
      },
      objectDelete: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      startNo () {
        return (this.pageNo - 1) * this.perPage
      },
      endNo () {
        return this.pageNo * this.perPage
      },
      pages () {
        return Math.ceil(this.filteredData.length / this.perPage)
      },
      displayData () {
        return this.filteredData.slice(this.startNo, this.endNo)
      }
    },
    data: function () {
      var sortOrders = {}
      var tableFields = this.listDefinition.tableFields
      tableFields.forEach(function (field) {
        sortOrders[field.name] = 1
      })
      return {
        sortKey: this.listDefinition.sortKey || '',
        sortOrders: sortOrders,
        data: [],
        search: [],
        option: [],
        filteredData: [],
        pageNo: 1,
        perPage: 25,
        object: {},
        tableFields,
        tableLinks: this.listDefinition.tableLinks,
        bulkEdit: this.listDefinition.bulkEdit,
        list_urls: this.listDefinition.urls,
        title: this.listDefinition.title,
        filter: false,
        multiSelect: [],
        selectAll: false,
        multiSelectCount: 0,
        objects: [],
        total: 0,
        current: 0,
        isLoading: false
      }
    },
    methods: {
      getObjects: function () {
        store.commit('setLoading', true)
        var self = this
        const path = `${self.list_urls.getObjects.url}`
        const id = self.id ? self.id : null
        const url = self.client.methods.api_url(path, id)
        const options = self.client.methods.api_options()
        axios[self.list_urls.getObjects.method](url, options)
        .then(function (response) {
          const activeData = []
          response.data[self.listDefinition.name].forEach((data) => {
            if (data.active === 'yes') {
              activeData.push(data)
            }
          })
          activeData.forEach((data, i) => {
            data.index = i
            self.multiSelect[i] = false
            self.tableFields.forEach((field) => {
              data[field.name] = _.get(data, field.key)
            })
          })
          self.data = activeData
          self.filteredData = activeData
          if (self.sortKey) {
            self.sortBy(self.sortKey)
          }
          self.tableFields.forEach(function (field) {
            if (field.type === 'text') {
              self.option[field.name] = 'Starts with'
            }
          })
          store.commit('setLoading', false)
        })
        .catch(function (error) {
          console.log(error)
          store.commit('setLoading', false)
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        })
      },
      sortBy: function (key) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.filteredData
        if (sortKey) {
          data = data.sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        this.filteredData = data
      },
      clearAll () {
        var self = this
        self.filteredData = self.data
        self.tableFields.forEach((field) => {
          self.search[field.name] = null
          if (field.type === 'text') {
            self.option[field.name] = 'Starts with'
          }
        })
        self.filter = false
      },
      filteredObject: async function () {
        var self = this
        var flag = false
        self.tableFields.forEach((field) => {
          if (self.search[field.name]) {
            flag = true
          }
        })
        if (flag) {
          self.filteredData = self.data.filter(self.filterList)

          var count = 0
          self.multiSelect = await Promise.all(self.multiSelect.map(async (select, i) => {
            if (select) {
              if (_.findIndex(self.filteredData, (data) => { return data.index === i }) > -1) {
                count = count + 1
                return true
              }
              return false
            }
            return false
          }))
          self.multiSelectCount = count
        } else {
          self.filteredData = self.data
        }
        self.filter = flag
        self.pageNo = 1
      },
      filterList (object) {
        var self = this
        var result = true
        self.tableFields.forEach((field) => {
          if (field.type === 'text') {
            if (self.option[field.name] === 'Contains') {
              if (self.search[field.name] && object[field.name].toString().toLowerCase().indexOf(self.search[field.name].toString().toLowerCase()) < 0) {
                result = false
              }
            } else if (self.option[field.name] === 'Exact match') {
              if (self.search[field.name] && object[field.name].toString().toLowerCase() !== self.search[field.name].toString().toLowerCase()) {
                result = false
              }
            } else if (self.option[field.name] === 'Starts with') {
              if (self.search[field.name] && !object[field.name].toString().toLowerCase().startsWith(self.search[field.name].toString().toLowerCase())) {
                result = false
              }
            } else if (self.option[field.name] === 'Ends with') {
              if (self.search[field.name] && !object[field.name].toString().toLowerCase().endsWith(self.search[field.name].toString().toLowerCase())) {
                result = false
              }
            }
          } else if (field.type === 'range') {
            let originalValue = 0
            let searchedValue = 0
            if (field.range_type === 'integer') {
              originalValue = parseInt(object[field.name])
              searchedValue = parseInt(self.search[field.name])
            } else if (field.range_type === 'float') {
              originalValue = parseFloat(object[field.name])
              searchedValue = parseFloat(self.search[field.name])
            }
            if (self.option[field.name] === '==') {
              if (self.search[field.name] && originalValue !== searchedValue) {
                result = false
              }
            } else if (self.option[field.name] === '!=') {
              if (self.search[field.name] && originalValue === searchedValue) {
                result = false
              }
            } else if (self.option[field.name] === '>') {
              if (self.search[field.name] && originalValue <= searchedValue) {
                result = false
              }
            } else if (self.option[field.name] === '<') {
              if (self.search[field.name] && originalValue >= searchedValue) {
                result = false
              }
            } else if (self.option[field.name] === '>=') {
              if (self.search[field.name] && originalValue < searchedValue) {
                result = false
              }
            } else if (self.option[field.name] === '<=') {
              if (self.search[field.name] && originalValue > searchedValue) {
                result = false
              }
            }
          } else if (field.type === 'list') {
            if (self.search[field.name] && object[field.name].toString().toLowerCase().indexOf(self.search[field.name].toString().toLowerCase()) < 0) {
              result = false
            }
          }
        })
        return result
      },
      removeFunction (index) {
        var self = this
        self.search[index] = ''
        if (self.option[index]) {
          self.option[index] = 'Starts with'
        }
        self.filteredObject()
      },
      onChangePage (n) {
        this.pageNo = n
      },
      onNextPage () {
        this.pageNo = this.pageNo < this.pages ? this.pageNo + 1 : this.pageNo
      },
      onPreviousPage () {
        this.pageNo = this.pageNo > 1 ? this.pageNo - 1 : this.pageNo
      },
      onFirstPage () {
        this.pageNo = 1
      },
      onLastPage () {
        this.pageNo = this.pages
      },
      perPageChange (event) {
        var self = this
        if (event.target.value !== '') {
          self.perPage = parseInt(event.target.value)
          if (self.pageNo > self.pages) {
            self.pageNo = self.pages
          }
        }
      },
      multiSelectChange: async function () {
        var self = this
        var count = 0
        await Promise.all(self.multiSelect.map((select) => {
          if (select) {
            count = count + 1
          }
        }))
        self.multiSelectCount = count
      },
      multiSelectAll: async function () {
        var self = this
        if (!self.selectAll) {
          var count = 0
          await Promise.all(self.filteredData.map((data) => {
            count = count + 1
            self.multiSelect[data.index] = true
          }))
          self.multiSelectCount = count
        } else {
          self.multiSelect = await Promise.all(self.multiSelect.map((select) => {
            return false
          }))
          self.multiSelectCount = 0
        }
        self.selectAll = !self.selectAll
      },
      buttonMultiEdit: async function () {
        var self = this
        const objects = []
        await Promise.all(self.multiSelect.map(async (select, i) => {
          if (select) {
            await Promise.all(self.data.map((data) => {
              if (data.index === i) {
                objects.push(data[self.bulkEdit.id])
              }
            }))
          }
        }))
        self.multiSelectAction(objects)
      },
      buttonMultiDelete: async function () {
        var self = this
        self.objects = []
        await Promise.all(self.multiSelect.map(async (select, i) => {
          if (select) {
            await Promise.all(self.data.map((data) => {
              if (data.index === i) {
                self.objects.push(data[self.bulkEdit.id])
              }
            }))
          }
        }))
        self.$refs.multiDeleteModal.open()
      },
      multiDelete: async function () {
        try {
          var current = 0
          var self = this
          self.total = self.objects.length
          self.current = current
          self.isLoading = true
          self.$refs.multiDeleteModal.cancel()
          // Configure API Call
          const path = `${self.list_urls.deleteObject.url}`
          const options = await self.client.methods.api_options()
          await Promise.all(self.objects.map(async (id) => {
            try {
              const url = await self.client.methods.api_url(path, id)
              await axios[self.list_urls.deleteObject.method](url, options)
              current = current + 1
              self.current = current
            } catch (error) {
              console.log(error)
              self.localAlert = true
              self.localAlertMessage = error.response.data.message
              store.commit('setLoading', false)
              if (error.response.status === 401) {
                self.$router.push({ name: 'Logout' })
              } else {
                self.getObject()
              }
            }
          }))
          self.isLoading = false
          self.multiSelectCount = 0
          self.getObjects()
        } catch (error) {
          console.log(error)
          self.isLoading = false
          self.multiSelectCount = 0
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          } else {
            self.getObjects()
          }
        }
      },
      hideMultiDeleteModal () {
        var self = this
        self.$refs.multiDeleteModal.cancel()
      }
    }
  }
</script>
<style lang="scss">
  @import "../../../../sass/variables";

  th.active{
  color: $fractel-teal;
  }

  th.active .arrow {
  opacity: 1;
  }

  .arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0;
  }

  .arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
  }

  .arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
  }

  .search-input {
    border: 1px solid black;
    border-radius: 5px;
  }

  .pagination-input {
    margin-left: 1em;
    border: 0.1em solid black;
    border-radius: 0.5em;
    max-width: 3.5em;
    line-height: 3em;
    text-align: center;
  }

  /* Vuestic Widget */
  .widget {
    background: $widget-bg;
    box-shadow: $widget-box-shadow;
    margin-bottom: $widget-mb;
    padding: 0;

    &.no-header {
      .widget-body {
        height: $widget-body-no-header-height;
      }
    }

    &.larger-padding {
      .widget-body {
        padding: $widget-larger-padding;
      }
    }

    &.no-h-padding {
      .widget-body {
        padding-left: 0;
        padding-right: 0;
      }
    }

    &.no-v-padding {
      .widget-body {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    &.brand-info {
      background-color: $brand-info;
      color: $white;
      box-shadow: $widget-info-shadow;
    }

    &.brand-danger {
      background-color: $brand-danger;
      color: $white;
      box-shadow: $widget-danger-shadow;
    }

    &.info-widget {
      border-top: $info-widget-border;

      &.brand-info {
        border-top-color: $brand-info;
      }

      &.brand-danger {
        border-top-color: $brand-danger;
      }
    }

    .widget-body {
      height: $widget-body-with-header-height;
      padding: $widget-padding;
    }

    .widget-header {
      height: $widget-header-height;
      padding: 0 $widget-padding;
      border-bottom: $widget-header-border;
      font-size: $font-size-larger;
      font-weight: 600;
      display: flex;
      align-items: center;
    }
  }

  .add {
    margin-left: 0.5em;
    color: $fractel-teal;
    cursor: pointer;
  }
  .filter-input {
    border: 0.1em solid grey;
    border-radius: 0.25em;
  }
  .clear-filter:hover {
    color: $fractel-teal;
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/objects/table/TableActive.vue